import { useQuery } from '@tanstack/react-query'
import { getPromotionTypes } from '@/services/PromotionsService/promotions'

export const usePromotionTypes = () => {
  const { data, isLoading, error } = useQuery({
    queryKey: ['PROMOTION_TYPES'],
    queryFn: getPromotionTypes,
  })
  return {
    promotionTypes: data?.data?.promotionType,
    isLoading,
    error,
  }
}